import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap"
import { formatTime } from "../functions"

const ShowcaseCards = data => {
  // console.log(data.type)

  // Gracefully handle unknown types
  let type = data.type
  // try { type = data.props.relationships.field_content_type.info } catch (e) {}
  // console.log(type)

  let entries
  switch (type) {
    case "Article (Cards)":
      entries = data.data.allNodeArticle.edges
      return <Article data={entries} />
    case "Case Study (Cards)":
      entries = data.data.allNodeCaseStudy.edges
      return <CaseStudy data={entries} />
    case "Team Member (Cards)":
      entries = data.data.allNodeTeamMember.edges
      return <TeamMember data={entries} icon={data.data.linkedin} />
    default:
      return <p>[No data found]</p>
  }
}

const Article = ({ data }) => {
  // console.log(data)

  return (
    <Container style={{ paddingTop: "10px" }}>
      <Row>
        {data.map((entry, key) => {
          // console.log(entry.node)
          return (
            <Col
              xs={12}
              md={6}
              xl={3}
              className={"text-left"}
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
                // paddingTop: "15px",
                paddingBottom: "20px",
              }}
              key={key}
            >
              <Link
                to={entry.node.path.alias}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    boxShadow: "rgba(0, 0, 0, .5) 5px 5px 15px",
                    height: "100%",
                  }}
                >
                  <Col
                    xs={12}
                    style={{
                      paddingTop: "150px",
                      paddingBottom: "30px",
                    }}
                  >
                    {// Background Image
                    entry.node.relationships.field_image && (
                      <GatsbyImage
                        image={entry.node.relationships.field_image.relationships
                          .field_media_image.localFile.childImageSharp.gatsbyImageData}
                        imgStyle={{ objectFit: "cover" }}
                        alt={
                          entry.node.relationships.field_image.field_media_image
                            .alt
                        }
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          height: "100%",
                          width: "100%",
                        }} />
                    )}
                  </Col>
                  <Col
                    xs={12}
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <time>{formatTime(entry.node.created)}</time>
                    <h6 style={{ padding: 0, margin: 0 }}>
                      {entry.node.relationships.field_type.name}
                    </h6>
                    <h5
                      style={{
                        padding: 0,
                        marginTop: "0.25em",
                        marginBottom: "0.25em",
                      }}
                    >
                      {entry.node.title}
                    </h5>
                    {/* <p>{entry.node.field_summary}</p> */}
                  </Col>
                </div>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

const CaseStudy = ({ data }) => {
  const Film = ({ entry }) => {
    const dark = entry.node.relationships.field_organisation.relationships
      .field_icon_light
      ? true
      : false
    return (
      <div
        style={{
          backgroundColor: dark
            ? "rgba(35, 31, 32, 0.8)"
            : "rgba(250, 250, 250, 0.8)",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />
    )
  }
  const Icon = ({ entry }) => {
    if (
      entry.node.relationships.field_organisation.relationships.field_icon_light
    ) {
      return entry.node.relationships.field_organisation.relationships
        .field_icon_light.relationships.field_media_image.localFile
        .childImageSharp ? (
        <GatsbyImage
          image={entry.node.relationships.field_organisation.relationships
            .field_icon_light.relationships.field_media_image.localFile.childImageSharp.gatsbyImageData}
          className={"d-block m-auto"}
          imgStyle={{ objectFit: "contain" }}
          alt={entry.node.relationships.field_organisation.title} />
      ) : (
        <img
          src={
            entry.node.relationships.field_organisation.relationships
              .field_icon_light.relationships.field_media_image.localFile
              .publicURL
          }
          alt={entry.node.relationships.field_organisation.title}
          style={{
            position: "relative",
            height: "128px",
            maxWidth: "100%",
          }}
        />
      );
    } else if (
      entry.node.relationships.field_organisation.relationships.field_icon_dark
    ) {
      if (
        entry.node.relationships.field_organisation.relationships
          .field_icon_dark.relationships.field_media_image.localFile
          .childImageSharp
      ) {
        return (
          <GatsbyImage
            image={entry.node.relationships.field_organisation.relationships
              .field_icon_dark.relationships.field_media_image.localFile.childImageSharp.gatsbyImageData}
            className={"d-block m-auto"}
            imgStyle={{ objectFit: "contain" }}
            alt={entry.node.relationships.field_organisation.title}
            style={{
              display: "block",
            }} />
        );
      } else {
        return (
          <img
            src={
              entry.node.relationships.field_organisation.relationships
                .field_icon_dark.relationships.field_media_image.localFile
                .publicURL
            }
            alt={entry.node.relationships.field_organisation.title}
            style={{
              position: "relative",
              height: "128px",
              maxWidth: "100%",
            }}
          />
        )
      }
    } else {
      return null
    }
  }

  return (
    <Container style={{ paddingTop: "10px" }}>
      <Row>
        {data.map((entry, key) => {
          return (
            <Col
              xs={12}
              md={6}
              xl={3}
              className={"text-left"}
              key={key}
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
                // paddingTop: "15px",
                paddingBottom: "20px",
              }}
            >
              <Link
                to={entry.node.path.alias}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <div
                  className={"drop-shadow"}
                  style={{ backgroundColor: "#ffffff", height: "100%" }}
                >
                  <Col
                    xs={12}
                    className={"text-center"}
                    style={{
                      paddingTop: "30px",
                      paddingBottom: "30px",
                    }}
                  >
                    {// Background Image
                    entry.node.relationships.field_image && (
                      <GatsbyImage
                        image={entry.node.relationships.field_image.relationships
                          .field_media_image.localFile.childImageSharp.gatsbyImageData}
                        imgStyle={{ objectFit: "cover" }}
                        alt={entry.node.relationships.field_organisation.title}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          height: "100%",
                          width: "100%",
                        }} />
                    )}
                    <Film entry={entry} />
                    <Icon entry={entry} />
                  </Col>
                  <Col
                    xs={12}
                    style={{
                      paddingTop: "30px",
                      paddingBottom: "30px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <h4 style={{ color: "#1A75BB", marginBottom: "0.25em" }}>
                      {entry.node.title}
                    </h4>
                    <p
                      style={{
                        color: "inherit",
                        fontWeight: "bold",
                        fontSize: "1.4rem",
                      }}
                    >
                      {entry.node.relationships.field_organisation.title}
                    </p>
                  </Col>
                </div>
              </Link>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

const TeamMember = props => {
  return (
    <Container style={{ paddingTop: "10px" }}>
      <Row>
        {props.data.map((entry, key) => {
          // console.log(entry.node)
          return (
            <Col
              xs={12}
              md={6}
              xl={4}
              className={"text-left"}
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
                // paddingTop: "15px",
                paddingBottom: "20px",
              }}
              key={key}
            >
              <div
                style={{
                  backgroundColor: "#ffffff",
                  boxShadow: "rgba(0, 0, 0, .5) 5px 5px 15px",
                  height: "100%",
                }}
              >
                <Col
                  xs={12}
                  style={{
                    paddingTop: "300px",
                    paddingBottom: "30px",
                  }}
                >
                  {// Background Image
                  entry.node.relationships.field_image && (
                    <GatsbyImage
                      image={entry.node.relationships.field_image.relationships
                        .field_media_image.localFile.childImageSharp.gatsbyImageData}
                      imgStyle={{ objectFit: "cover" }}
                      alt={
                        entry.node.relationships.field_image.field_media_image
                          .alt
                      }
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                      }} />
                  )}
                </Col>
                <Col
                  xs={12}
                  style={{
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    backgroundColor: "#ffffff",
                  }}
                >
                  <h4
                    style={{
                      padding: 0,
                      marginTop: "0.25em",
                      marginBottom: "0.25em",
                    }}
                  >
                    {entry.node.title}
                  </h4>
                  <h5>{entry.node.field_job_title}</h5>
                  <a
                    href={entry.node.field_linkedin}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      src={props.icon.publicURL}
                      alt={"Linked-in"}
                      style={{ height: "40px" }}
                    />
                  </a>
                </Col>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

export default props => (
  <StaticQuery
    query={graphql`{
  linkedin: file(relativePath: {eq: "social-linkedin.svg"}) {
    publicURL
  }
  allNodeArticle(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_summary
        path {
          alias
        }
        relationships {
          field_type {
            name
          }
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  allNodeCaseStudy(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        path {
          alias
        }
        relationships {
          field_organisation {
            title
            field_link {
              uri
            }
            relationships {
              field_icon_dark {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(height: 120, layout: FIXED)
                      }
                      publicURL
                    }
                  }
                }
              }
              field_icon_light {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(height: 120, layout: FIXED)
                      }
                      publicURL
                    }
                  }
                }
              }
            }
          }
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  allNodeTeamMember(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        path {
          alias
        }
        field_job_title
        field_linkedin
        relationships {
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`}
    render={data => <ShowcaseCards data={data} {...props} />}
  />
)
